/* @ngInject */
export default function trustUrlFilter($sce) {
  return url => $sce.trustAsResourceUrl(url.$$unwrapTrustedValue())
}
